import { FiEye, FiEyeOff } from 'solid-icons/fi';
import type { VoidComponent} from 'solid-js';
import { Match, Switch, createSignal } from 'solid-js';
import type { StyleSafeComponentProps } from '@deltablue/ts-utils';
import c from './HiddenTextInput.module.css';
import ci from './TextInput.module.css';

type Props = Omit<StyleSafeComponentProps<'input'>, 'type'>;

export const HiddenTextInput: VoidComponent<Props> = p => {
    const [shown, setShown] = createSignal(false);
    return (
        <div class={c.wrapper}>
            <input
                class={[ci.input, c.input].join(' ')}
                type={shown() ? 'text' : 'password'}
                {...p}
            />
            <button
                type='button'
                class={c.toggle}
                onClick={() => setShown(s => !s)}
            >
                <Switch>
                    <Match when={shown()}>
                        <FiEyeOff class={c.toggleIcon} />
                    </Match>
                    <Match when={!shown()}>
                        <FiEye class={c.toggleIcon} />
                    </Match>
                </Switch>
            </button>
        </div>
    );
};
